import { styled } from '@material-ui/core';

export const NkInputLabel = styled('label')(({ theme }) => ({
  fontSize: '12px',
  fontWeight: 600,
  marginBottom: '4px',
}));
